import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import type { ErrorDialogPayload, ErrorDialogContextValue } from './types';

export const ErrorDialogContext = createContext<ErrorDialogContextValue | null>(null);

let externalShow: ((p: ErrorDialogPayload) => void) | null = null;

export function showErrorDialog(payload: ErrorDialogPayload): void {
  externalShow?.(payload);
}

export const ErrorDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [payload, setPayload] = useState<ErrorDialogPayload | null>(null);

  const show = useCallback((p: ErrorDialogPayload) => setPayload(p), []);
  const close = useCallback(() => setPayload(null), []);

  useEffect(() => {
    externalShow = show;
    return () => { externalShow = null; };
  }, [show]);

  return (
    <ErrorDialogContext.Provider value={{ showErrorDialog: show }}>
      {children}
      <Dialog open={!!payload} onClose={close} maxWidth="sm" fullWidth>
        <DialogTitle>{payload?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {payload?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={close} variant="contained">OK</Button>
        </DialogActions>
      </Dialog>
    </ErrorDialogContext.Provider>
  );
};
